export enum AuthorityYardManagement {
  YARDMANAGEMENT = '19.1',

  // FOLLOWUP
  YARDMANAGEMENT_FOLLOWUP_VIEW = '19.1.1',
  YARDMANAGEMENT_FOLLOWUP_CREATE_ACTIVITY = '19.1.2',
  YARDMANAGEMENT_FOLLOWUP_CREATE_STATUS = '19.1.3',
  YARDMANAGEMENT_FOLLOWUP_EDIT_STATUS = '19.1.4',
  YARDMANAGEMENT_FOLLOWUP_ORDER_STATUS = '19.1.5',
  YARDMANAGEMENT_FOLLOWUP_REMOVE_STATUS = '19.1.6',

  // ACTIVITY
  YARDMANAGEMENT_ACTIVITY_DETAIL_VIEW = '19.3.1',
  YARDMANAGEMENT_ACTIVITY_EDIT = '19.3.2',
  YARDMANAGEMENT_ACTIVITY_MOVE_CARD = '19.3.3',
  YARDMANAGEMENT_ACTIVITY_ADD_SERVICE = '19.3.4',
  YARDMANAGEMENT_ACTIVITY_EDIT_SERVICE = '19.3.5',
  YARDMANAGEMENT_ACTIVITY_MANAGE_SERVICE_TIME = '19.3.6',
  YARDMANAGEMENT_ACTIVITY_FINISH_SERVICE = '19.3.7',
  YARDMANAGEMENT_ACTIVITY_ADD_OBSERVATION = '19.3.8',
  YARDMANAGEMENT_ACTIVITY_EDIT_OWN_OBSERVATION = '19.3.9',
  YARDMANAGEMENT_ACTIVITY_REMOVE_OWN_OBSERVATION = '19.3.10',
  YARDMANAGEMENT_ACTIVITY_REMOVE_ANY_OBSERVATION = '19.3.11',
  YARDMANAGEMENT_ACTIVITY_VIEW_HISTORY = '19.3.12',

  // DIARY
  YARDMANAGEMENT_DIARY_VIEW_YARD = '19.2.1',
  YARDMANAGEMENT_DIARY_CREATE = '19.2.2',
  YARDMANAGEMENT_DIARY_EDIT = '19.2.3',
  YARDMANAGEMENT_DIARY_CLOSE = '19.2.4',
  YARDMANAGEMENT_DIARY_MOVE_CARD = '19.2.5',
  YARDMANAGEMENT_DIARY_CREATE_SITUATION = '19.2.6',
  YARDMANAGEMENT_DIARY_EDIT_SITUATION = '19.2.7',
  YARDMANAGEMENT_DIARY_ORDER_SITUATION = '19.2.8',
  YARDMANAGEMENT_DIARY_REMOVE_SITUATION = '19.2.9',
}
